export default "__VITE_ASSET__3eddcf24__"